import TossSettings from "./TossSettings";
export default TossSettings;
